import axios from "@/lib/axios";

export const getAllChapters = async () => {
  const { data } = await axios.get("/chapters");
  return data;
};

export const getChapter = async (id) => {
  const { data } = await axios.get(`/chapters/${id}`);
  return data;
};

export const createChapter = async (chapterData) => {
  const { data } = await axios.post("/chapters", chapterData);
  return data;
};

export const updateChapter = async ({ id, ...chapterData }) => {
  const { data } = await axios.put(`/chapters/${id}`, chapterData);
  return data;
};

export const deleteChapter = async (id) => {
  const { data } = await axios.delete(`/chapters/${id}`);
  return data;
};

export const getChapterStats = async () => {
  const { data } = await axios.get("/chapters/my-stats");
  return data.data;
};

export const downloadChapterWorkbook = async () => {
  const response = await axios.get("/chapters/my-export", {
    responseType: "blob",
  });

  const disposition = response.headers["content-disposition"];
  const fileNameMatch = disposition?.match(/filename="?([^\"]+)"?/i);
  const fileName =
    fileNameMatch?.[1] ||
    `chapter-payments-sponsorships-${new Date().toISOString().split("T")[0]}.xlsx`;

  return {
    blob: response.data,
    fileName,
  };
};

export const updateTargetConfig = async ({ id, ...configData }) => {
  const { data } = await axios.put(`/chapters/${id}/target-config`, configData);
  return data.data;
};

export const getAllChaptersStats = async () => {
  const { data } = await axios.get("/chapters/all-stats");
  return data.data;
};
